import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { ImageCornSchema, InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const DeleteImageApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        imageId: ImageCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
};
export const DeleteImageRequestSchema = DeleteImageApiSchema.params.merge(DeleteImageApiSchema.headers);
